import { createPersistStore, createSetState } from '@flowus/common/zustand/utils';

export const $screenLock = createPersistStore<{ enable: boolean }>('$screenLock', () => ({
  enable: false,
}));

export const setScreenLock = createSetState($screenLock);

export const useScreenLock = () => $screenLock((state) => state.enable);
